import { render, staticRenderFns } from "./PatentView.vue?vue&type=template&id=39558971&"
import script from "./PatentView.vue?vue&type=script&lang=ts&"
export * from "./PatentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports